import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa'; 
import YouTubePlayer from './YoutubePlayer';
import './VideoPlayerPage.css'; 

const VideoPlayerPage = () => {
    const { videoId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        if (location.state && location.state.activeIndex !== undefined) {
            navigate('/', { state: { activeIndex: location.state.activeIndex } }); 
        } else {
            navigate('/'); 
        }
    };

    return (
        <div className="video-player-page">
            <button onClick={handleBack} className="back-button">
                <FaArrowLeft size={40} /> 
            </button>
            <div className="video-container">
                <YouTubePlayer videoId={videoId} />
            </div>
        </div>
    );
};

export default VideoPlayerPage;
